import { createSelector } from 'reselect'

export const getListings = createSelector(
  state => state && state.ads && Array.isArray(state.ads.listings) ? state.ads.listings : [],
  listings => listings
)
